import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectRank = (state : GlobalState) => state.servers.rank;

export const serversRankSelector = createSelector(
    [selectRank],
    (data ) => data
)
